<template>
  <div class="detail-main" v-if="data_ok">
    <Header ref="header"/>
    <div class="main-1200-width padding-bottom-40">
      <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item,index) in detailData.crumbs" :key="index" :to="{path: 'Screen', name: 'Screen', params: {cate_id: item.id}}">{{item.name}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{detailData.title}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="detail-head">
        <div class="detail-carousel">
          <el-carousel height="420px" :autoplay="false" :interval="5000" arrow="always">
            <el-carousel-item v-for="(item,index) in detailData.images" :key="index">
              <img class="detail-carousel-img" :src="$url.cdn(item)" alt="">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="detail-other">
          <div class="detail-other-main">
            <div class="detail-other-box">
              <p class="detail-other-title">{{detailData.title}}</p>
              <p v-if="is_login && showSeckillPriceBlock" class="detail-other-price detail-seckill-price">
                <span class="detail-seckill-badge">秒杀</span>
                <span class="detail-seckill-label">秒杀价</span>
                <span class="detail-seckill-now">￥{{ price }}</span>
                <span v-if="seckillRefPriceDisplay" class="detail-seckill-ref">￥{{ seckillRefPriceDisplay }}</span>
              </p>
              <p v-else-if="is_login" class="detail-other-price">价格：￥{{price}}<span class="detail-other-vip-price" v-if="vip_price > 0"><img src="@/assets/vip_price.png" alt="会员价">￥{{vip_price}}</span></p>
              <p v-else class="detail-other-price">价格：**** <a href="/login">登录后查看</a></p>
              <p v-if="!is_login" class="detail-member"><a href="/register">注册会员享受折扣</a></p>
            </div>
            <div class="detail-spec-box">
              <div class="spec" v-for="(item,index) in detailData.skus" :key="index" :data-spec_id="item.id">
                <div class="spec_name">{{item.name}}</div>
                <div class="spec_list">
                  <div v-for="(item1,index1) in item.children" :key="index1"
                    :data-spec_price="specRefPriceForItem(item1)"
                    :data-spec_vip_price="specSalePriceForItem(item1)"
                    :data-goods_spec="skuPriceRowForItem(item1) && skuPriceRowForItem(item1).id"
                    :data-min_number="skuPriceRowForItem(item1) && skuPriceRowForItem(item1).min_number"
                    :data-spec_id="item.id"
                    :data-spec_item_id="item1.id"
                    class="spec_item" :class="spec_item_id === item1.id ?'spec_active':''"
                    @click="specClick"
                    >{{item1.name}}</div>
                </div>
              </div>
              <div class="shopping_amount">
                <div class="spec_name">购买数量</div>
                <el-input-number class="shopping_amount_input" v-model="amount" :min="minNumber" label="描述文字"></el-input-number>
              </div>
            </div>
            <div class="detail-other-btns">
              <div class="detail-other-btn detail-other-btn1" @click="purchase">
                <span class="el-icon el-icon-shopping-cart-2"></span>订购
              </div>
              <div :class="is_collection" class="detail-other-btn detail-other-btn2" @click="collect">
                <span :class="is_collection_icon" class="el-icon el-icon-star-off"></span><span>{{collect_title}}</span>
              </div>
            </div>
            <div class="detail-other-tag">
              <div class="detail-other-tag-item" v-for="(item, index) in detailData.service" :key="index"><span class="el-icon el-icon-circle-check"></span>{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-info">
        <div class="detail-left-recommend">
          <div class="detail-left-recommend-title">达人选购</div>
          <div class="detail-left-recommend-list">
            <a v-for="(item,index) in recommend" :key="index" class="recommend-item" :href="'/GoodsDetail?id='+item.id" :title="item.name">
              <img class="recommend-item-img" :src="$url.cdn(item.image)" alt="">
              <div class="recommend-item-title">{{item.name}}</div>
              <div class="recommend-item-price">¥{{ formatPrice(item.price) }}</div>
            </a>
          </div>
        </div>
        <div class="detail-right-info">
          <el-tabs type="border-card">
            <el-tab-pane label="商品详情">
              <div class="detail-right-content">
                <div class="pro-disclaimer-area ma-to-20" v-html="detailData.content"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="规格参数">
              <div class="detail-right-spec">
                <p class="detail-right-spec-title">商品属性</p>
                <div class="detail-right-spec-info">
                  <p v-for="(item_a,index_a) in detailData.params" :key="index_a">{{item_a.title}}：{{item_a.content}}</p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import Header from "@/globalComponents/Header";
  import Footer from "@/globalComponents/Footer";
  import $store from "@/store";
  import userApi from "@/api/user.js";
  import goodsApi from "@/api/goods.js";
  import activityApi from "@/api/activity.js";
  import { isSeckillActivityEnded } from "@/units/seckillLive.js";
  import {
    parseSeckillSkuPair,
    formatActivityMoneyDisplay,
    mergeActivitySkuIntoSkuPrices,
    normalizeGoodsSkuPriceArrays,
    getSeckillSkuCatalogPrice,
    findSkuPriceRowBySpecItemId,
    resolveSeckillSpecSelection,
  } from "@/units/activityGoodsPrice.js";
  import { mergeActivitySkuPricesFromActivityEndpoint } from "@/units/enrichSeckillGoodsFromDetail.js";
  import { setCartActivityHint } from "@/units/cartActivityHint.js";
  import { resolveSeckillActivityIdForGoods } from "@/units/resolveSeckillActivityId.js";
  import { MessageBox } from "element-ui";
  export default {
    data() {
      return {
        data_ok           : false,
        active            : 0,
        price             : 0,
        vip_price         : 0,
        amount            : 1,
        minNumber         : 1,
        spec_id           : 0,
        spec_item_id      : 0,
        goods_spec_id     : 0,
        is_collection     : false,
        is_collection_icon: false, //'el-icon-star-on'
        detailData        : {},
        recommend         : [],
        collect_ok        : false,
        collect_title     : '收藏',
        /** 无 URL activity_id 时自动解析的秒杀活动 */
        autoActivityId    : '',
        suppressRouteReload: false,
      };
    },
    computed: {
      ...mapGetters(['is_login', 'tenant_id']),
      /** 路由参数优先，否则使用自动识别的秒杀活动 */
      effectiveActivityId() {
        const q = this.$route.query && this.$route.query.activity_id;
        if (q != null && q !== '') return String(q);
        return this.autoActivityId || '';
      },
      skuPrices() {
        let skuPrices =
          this.detailData.sku_prices ||
          this.detailData.new_sku_prices ||
          [];
        if (!Array.isArray(skuPrices)) skuPrices = [];
        if (this.detailData.is_sku) {
          skuPrices.forEach((item) => {
            if (item && item.goods_sku_ids != null && item.goods_sku_ids !== '') {
              item.goods_sku_id_arr = String(item.goods_sku_ids).split(',');
            }
          });
        }
        return skuPrices;
      },
      /** 秒杀进行中才显示秒杀价区块（活动结束仍带 activity_id 时用普通价） */
      showSeckillPriceBlock() {
        return this.detailData.activity_type === 'seckill';
      },
      /** 秒杀场景下展示划线「原价」（数值来自 data 中与秒杀价对应的对比价） */
      seckillRefPriceDisplay() {
        if (!this.showSeckillPriceBlock) return '';
        const v = this.vip_price;
        if (v === null || v === undefined || v === '' || Number(v) === 0) return '';
        return v;
      },
    },
    created() {
      this.getData();
    },
    watch: {
      // 同一组件实例下切换商品 id 或活动 activity_id（如秒杀列表连续进入详情）时需重新拉取
      '$route'(to, from) {
        if (to.name !== 'GoodsDetail') return;
        if (!from || from.name !== 'GoodsDetail') return;
        const idChanged = String(to.query.id || '') !== String(from.query.id || '');
        const actChanged =
          String(to.query.activity_id || '') !== String(from.query.activity_id || '');
        if (idChanged || actChanged) {
          // 自动补全 activity_id 的 replace 不重新拉数，避免 data_ok 被置 false 后页面空白
          if (this.suppressRouteReload) {
            this.suppressRouteReload = false;
            return;
          }
          this.autoActivityId = '';
          this.data_ok = false;
          this.getData();
        }
      },
    },
    methods   : {
      async syncActivityIdQuery(activityId) {
        if (!activityId) return;
        if (String(this.$route.query.activity_id || '') === String(activityId)) return;
        this.suppressRouteReload = true;
        await this.$router.replace({
          name: 'GoodsDetail',
          query: { ...this.$route.query, activity_id: activityId },
        });
      },
      formatPrice(e) {
          if (e == null || e === '') return '';
          if (typeof e === 'number' && Number.isFinite(e)) return String(e);
          if (!Array.isArray(e)) return String(e);
          return e.length === 1 ? e[0] : e.join('~');
      },
      /**
       * 秒杀价：与 activityGoodsPrice.parseSeckillSkuPair 同一套规则（活动价列 / recover）。
       */
      getSeckillSkuSalePrice(sp) {
        if (!sp) return '';
        const { sale } = parseSeckillSkuPair(sp);
        if (!Number.isNaN(sale)) return formatActivityMoneyDisplay(sale);
        const g = this.detailData;
        if (g && g.min_activity_price != null && String(g.min_activity_price).trim() !== '') {
          const m = parseFloat(String(g.min_activity_price).replace(/,/g, ''));
          if (!Number.isNaN(m)) return formatActivityMoneyDisplay(m);
        }
        return '';
      },
      skuPriceRowForItem(item1) {
        if (!item1 || item1.id == null) return null;
        return findSkuPriceRowBySpecItemId(this.skuPrices, item1.id);
      },
      /**
       * 划线价：同档「价格」列（日常价）；recover 时为 old_price；最后才用档案 original_price。
       */
      getSeckillSkuRefPrice(sp) {
        if (!sp) return '';
        const { sale, listPrice } = parseSeckillSkuPair(sp);
        if (!Number.isNaN(sale)) {
          let ref = listPrice;
          if (Number.isNaN(ref) || ref <= sale + 0.001) {
            const cat = getSeckillSkuCatalogPrice(sp);
            if (!Number.isNaN(cat) && cat > sale + 0.001) ref = cat;
          }
          if (!Number.isNaN(ref) && ref > sale + 0.001) return formatActivityMoneyDisplay(ref);
        }
        const catOnly = getSeckillSkuCatalogPrice(sp);
        if (!Number.isNaN(catOnly) && catOnly > 0) {
          return formatActivityMoneyDisplay(catOnly);
        }
        return '';
      },
      /** 规格行：对比价（原价/划线） */
      specRefPriceForItem(item1) {
        const sp = this.skuPriceRowForItem(item1);
        if (!sp) return '';
        if (this.detailData.activity_type === 'seckill') {
          let ref = this.getSeckillSkuRefPrice(sp);
          if (!ref && this.detailData.original_goods_price) {
            const og = this.formatPrice(this.detailData.original_goods_price);
            if (og) ref = og;
          }
          return ref;
        }
        return sp.original_price;
      },
      /** 规格行：实际售价（含秒杀价、会员价） */
      specSalePriceForItem(item1) {
        const sp = this.skuPriceRowForItem(item1);
        if (!sp) return '';
        if (this.detailData.activity_type === 'seckill') {
          return this.getSeckillSkuSalePrice(sp);
        }
        return sp.price;
      },
      specClick(e) {
        let data = e.target;
        // 秒杀：dataset 中 spec_vip_price 存实际秒杀价，spec_price 存对比原价（与下方 getData 默认选中一致）
        if (this.detailData.activity_type === 'seckill') {
          this.price = data.dataset.spec_vip_price;
          this.vip_price = data.dataset.spec_price;
        } else {
          this.price = data.dataset.spec_price;
          this.vip_price = data.dataset.spec_vip_price;
        }
        this.spec_id = parseInt(data.dataset.spec_id);
        this.spec_item_id = parseInt(data.dataset.spec_item_id);
        this.goods_spec_id = parseInt(data.dataset.goods_spec);
        this.amount = parseInt(data.dataset.min_number)
        this.minNumber = parseInt(data.dataset.min_number)
      },
      async getData() {
        try {
          const goodsId = this.$route.query['id'];
          let activityId = this.effectiveActivityId;

          if (!activityId) {
            const preview = await goodsApi.detail(goodsId, {});
            const autoId = await resolveSeckillActivityIdForGoods(goodsId, preview.data);
            if (autoId) {
              this.autoActivityId = autoId;
              activityId = autoId;
            } else {
              this.autoActivityId = '';
            }
          } else {
            this.autoActivityId = '';
          }

          let {data: detailData} = await goodsApi.detail(
            goodsId,
            activityId ? { activity_id: activityId } : {}
          );

          // URL 指定 activity_id 但商品未加入该活动 / 接口未带秒杀：回退自动识别（与小程序一致）
          if (detailData.activity_type !== 'seckill') {
            const autoId = await resolveSeckillActivityIdForGoods(goodsId, detailData);
            if (autoId && String(autoId) !== String(activityId || '')) {
              activityId = autoId;
              if (!this.$route.query.activity_id) {
                this.autoActivityId = autoId;
              }
              const res2 = await goodsApi.detail(goodsId, { activity_id: activityId });
              if (res2 && res2.data) {
                detailData = res2.data;
              }
            }
          }

          const now = Math.floor(Date.now() / 1000);
          if (detailData.activity_type === 'seckill') {
            const aid = activityId || (detailData.activity && detailData.activity.id);
            let actRow = detailData.activity;
            if (aid && (!actRow || actRow.end_time == null || actRow.end_time === '')) {
              try {
                const actRes = await activityApi.activity(aid);
                const row = actRes && actRes.data;
                if (row) {
                  actRow = { ...(actRow || {}), ...row };
                  detailData = { ...detailData, activity: actRow };
                }
              } catch (e) {
                actRow = detailData.activity || actRow;
              }
            }
            if (actRow && isSeckillActivityEnded(actRow, now)) {
              detailData = { ...detailData, activity_type: '' };
            }
          }

          if (detailData && detailData.activity_type === 'seckill') {
            detailData = mergeActivitySkuIntoSkuPrices(detailData)
          }
          detailData = normalizeGoodsSkuPriceArrays(detailData)
          if (detailData && detailData.activity_type === 'seckill' && activityId) {
            detailData = await mergeActivitySkuPricesFromActivityEndpoint(detailData, activityId)
          }

          this.price = this.formatPrice(detailData.price)
          this.detailData = detailData;

          // 非多规格 + 秒杀：接口已返回活动价区间；对比价用 original_goods_price
          if (detailData.activity_type === 'seckill' && !detailData.is_sku) {
            this.price = this.formatPrice(detailData.price);
            if (detailData.original_goods_price && detailData.original_goods_price.length) {
              this.vip_price = this.formatPrice(detailData.original_goods_price);
            } else {
              this.vip_price = 0;
            }
          }

          // 默认选中规格：按规格项 id 匹配 sku_prices（与小程序一致，不用 children 下标）
          if (this.detailData && this.detailData.is_sku && this.detailData.skus && this.detailData.skus.length) {
            const prices =
              this.detailData.sku_prices ||
              this.detailData.new_sku_prices ||
              []
            let pick = null
            if (this.detailData.activity_type === 'seckill') {
              pick = resolveSeckillSpecSelection(this.detailData.skus, prices)
            } else {
              const firstSpec = this.detailData.skus[0]
              const firstItem = firstSpec.children && firstSpec.children[0]
              const firstPrice = prices[0]
              if (firstSpec && firstItem && firstPrice) {
                pick = { specId: firstSpec.id, specItemId: firstItem.id, skuPrice: firstPrice }
              }
            }

            if (pick && pick.skuPrice) {
              this.spec_id = parseInt(pick.specId)
              this.spec_item_id = parseInt(pick.specItemId)
              this.goods_spec_id = parseInt(pick.skuPrice.id)
              if (this.detailData.activity_type === 'seckill') {
                this.price = this.getSeckillSkuSalePrice(pick.skuPrice)
                let ref = this.getSeckillSkuRefPrice(pick.skuPrice)
                if (!ref && this.detailData.original_goods_price) {
                  ref = this.formatPrice(this.detailData.original_goods_price)
                }
                this.vip_price = ref
              } else {
                this.price = pick.skuPrice.original_price
                this.vip_price = pick.skuPrice.price
              }
              this.amount = parseInt(pick.skuPrice.min_number || 1)
              this.minNumber = parseInt(pick.skuPrice.min_number || 1)
            }
          }


        // if (this.detailData.sku_prices.length > 0 && this.detailData.spec[0].spec_item.length > 0) {
        //   this.spec_item_id = this.detailData.spec[0].spec_item[0].id;
        //   this.spec_id = this.detailData.spec[0].id;
        //   this.price = this.detailData.spec[0].spec_item[0].price;
        //   this.vip_price = this.detailData.spec[0].spec_item[0].vip_price;
        //   this.goods_spec_id = this.detailData.spec[0].spec_item[0].goods_spec_item;
        // }

        if (this.detailData.favorite) {
          this.is_collection = 'yes';
          this.collect_title = '取消收藏';
          this.is_collection_icon = 'el-icon-star-on';
        }

          let {data: recommend}  = await goodsApi.list({category_id: detailData.category_ids[0], list_rows: 5})
          this.recommend = recommend.data;

          this.collect_ok = true;
          this.data_ok = true;

          if (activityId && String(this.$route.query.activity_id || '') !== String(activityId)) {
            await this.syncActivityIdQuery(activityId);
          }
        } catch (e) {
          // 商品不存在/被下架/不属于当前租户：避免未处理 Promise 导致 runtime overlay
          const msg = (e && (e.message || e.msg)) ? (e.message || e.msg) : '商品不存在'
          this.$message.error(msg)
          this.data_ok = false
          // 返回上一级或首页
          if (window.history.length > 1) {
            this.$router.back()
          } else {
            this.$router.push({ name: 'index' })
          }
        }
      },
      async purchase() { //购买
        if (!this.is_login) {
          const redirect = this.$route.fullPath || '/';
          let jumped = false;
          const timer = setTimeout(() => {
            jumped = true;
            this.$router.push({ name: 'Login', query: { redirect } });
          }, 3000);

          MessageBox.alert('请先登录后再订购，3秒后将自动跳转到登录页。', '提示', {
            confirmButtonText: '立即登录',
            showClose: false,
            type: 'warning',
            callback: () => {
              if (!jumped) {
                clearTimeout(timer);
                this.$router.push({ name: 'Login', query: { redirect } });
              }
            }
          }).catch(() => {});
          return;
        }

        let data = {
          goods_id: this.$route.query['id'],
          goods_num: this.amount,
          id: this.goods_spec_id,
        };
        // 含自动识别的秒杀 activity_id；后端命中活动规格时才按活动价
        if (this.effectiveActivityId) {
          data.activity_id = this.effectiveActivityId;
        }

        if ((this.skuPrices || []).length > 0 && data.id === 0) {
          this.$message({
            showClose: true,
            message  : '请选择规格',
            type     : 'error'
          });
          return false;
        }

        try {
          await $store.dispatch('cart/add', data);
          if (this.effectiveActivityId && data.id) {
            setCartActivityHint(this.tenant_id, this.$route.query['id'], data.id, this.effectiveActivityId);
          }
          this.$refs.header.getCartNum();
          this.$message.success('已加入购物车')
          if (this.$refs.header && this.$refs.header.flashCart) {
            this.$refs.header.flashCart()
          }
        } catch (e) {
          const msg = (e && (e.message || e.msg)) ? (e.message || e.msg) : '订购失败'
          this.$message.error(msg)
        }

      },
      async collect() { //收藏
        if (!this.is_login) {
          const redirect = this.$route.fullPath || '/';
          let jumped = false;
          const timer = setTimeout(() => {
            jumped = true;
            this.$router.push({ name: 'Login', query: { redirect } });
          }, 3000);

          MessageBox.alert('请先登录后再收藏，3秒后将自动跳转到登录页。', '提示', {
            confirmButtonText: '立即登录',
            showClose: false,
            type: 'warning',
            callback: () => {
              if (!jumped) {
                clearTimeout(timer);
                this.$router.push({ name: 'Login', query: { redirect } });
              }
            }
          }).catch(() => {});
          return;
        }

        await userApi.favorite.do(this.detailData.id);
        this.collect_ok = true;
        if (this.is_collection) {
          this.is_collection = false;
          this.collect_title = '收藏';
          this.is_collection_icon = false;
        } else {
          this.is_collection = 'yes';
          this.collect_title = '取消收藏';
          this.is_collection_icon = 'el-icon-star-on';
        }
      }
    },
    components: {
      Header,
      Footer
    }
  };
</script>
<style lang="less" scoped>
  @import url("detail.less");
</style>
